// Mock data for AI Healthcare Clone

export const doctors = {
  generalCare: [
    {
      id: 1,
      name: "Dr. Alex Morgan",
      specialty: "AI General Physician",
      image: "https://images.unsplash.com/photo-1612531385446-f7e6d131e1d0?w=400&h=400&fit=crop&crop=face",
      description: "Comprehensive primary care and health assessments",
      experience: "10+ years experience",
      availability: "Available 24/7"
    },
    {
      id: 2,
      name: "Dr. Emma Williams",
      specialty: "AI Family Doctor",
      image: "https://images.pexels.com/photos/5327580/pexels-photo-5327580.jpeg?w=400&h=400&fit=crop",
      description: "Family-centered healthcare for all ages",
      experience: "12+ years experience",
      availability: "Available 24/7"
    },
    {
      id: 3,
      name: "Dr. Noah Patel",
      specialty: "AI Pediatrician",
      image: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=400&h=400&fit=crop&crop=face",
      description: "Specialized care for infants, children, and adolescents",
      experience: "8+ years experience",
      availability: "Available 24/7"
    }
  ],
  lifestyle: [
    {
      id: 4,
      name: "Dr. Olivia Chen",
      specialty: "AI Dietitian / Nutritionist",
      image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=400&fit=crop&crop=face",
      description: "Evidence-based nutrition and dietary guidance",
      experience: "9+ years experience",
      availability: "Available 24/7"
    },
    {
      id: 5,
      name: "Dr. Liam Carter",
      specialty: "AI Fitness Trainer / Physiotherapy",
      image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=400&fit=crop&crop=face",
      description: "Movement optimization and physical rehabilitation",
      experience: "11+ years experience",
      availability: "Available 24/7"
    },
    {
      id: 6,
      name: "Dr. Sophia Khan",
      specialty: "AI Mental Health Therapist",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face",
      description: "Psychological wellness and stress management",
      experience: "10+ years experience",
      availability: "Available 24/7"
    }
  ],
  specialists: [
    {
      id: 7,
      name: "Dr. Daniel Smith",
      specialty: "AI Cardiologist",
      image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop&crop=face",
      description: "Heart and cardiovascular health specialist",
      experience: "15+ years experience",
      availability: "Available 24/7"
    },
    {
      id: 8,
      name: "Dr. Maya Gupta",
      specialty: "AI Neurologist",
      image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&h=400&fit=crop&crop=face",
      description: "Brain and nervous system expertise",
      experience: "13+ years experience",
      availability: "Available 24/7"
    },
    {
      id: 9,
      name: "Dr. Ethan Brown",
      specialty: "AI Orthopedic Doctor",
      image: "https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=400&h=400&fit=crop&crop=face",
      description: "Musculoskeletal health and injury treatment",
      experience: "14+ years experience",
      availability: "Available 24/7"
    }
  ]
};

export const teamAvatars = [
  "https://aihealthchoices.aihealthcarebuilder.com/assets/images/home-two/hero/author-img1.jpg",
  "https://aihealthchoices.aihealthcarebuilder.com/assets/images/home-two/hero/author-img2.jpg",
  "https://aihealthchoices.aihealthcarebuilder.com/assets/images/home-two/hero/author-img3.jpg"
];

export const aboutImages = {
  image1: "https://aihealthchoices.aihealthcarebuilder.com/assets/images/home-three/about/about-img1.jpg",
  image2: "https://aihealthchoices.aihealthcarebuilder.com/assets/images/home-three/about/about-img2.jpg"
};

export const features = [
  "Skilled AI Assistants",
  "24/7 Virtual Healthcare Support",
  "Powered by Advanced AI Technology",
  "Always Ready to Help You Anytime"
];

export const bannerImages = {
  banner1: "https://aihealthchoices.aihealthcarebuilder.com/home1.jpg",
  banner2: "https://aihealthchoices.aihealthcarebuilder.com/home2.jpg"
};

export const blogs = [
  {
    id: 1,
    title: "Understanding AI in Modern Healthcare",
    excerpt: "Discover how artificial intelligence is revolutionizing patient care and medical diagnostics.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400&h=300&fit=crop",
    date: "July 15, 2025",
    category: "Technology"
  },
  {
    id: 2,
    title: "Tips for Better Mental Health",
    excerpt: "Expert advice on maintaining your mental wellness in today's fast-paced world.",
    image: "https://images.unsplash.com/photo-1544027993-37dbfe43562a?w=400&h=300&fit=crop",
    date: "July 12, 2025",
    category: "Wellness"
  },
  {
    id: 3,
    title: "Nutrition Basics for Healthy Living",
    excerpt: "Learn the fundamentals of balanced nutrition and healthy eating habits.",
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&h=300&fit=crop",
    date: "July 10, 2025",
    category: "Nutrition"
  }
];

export const navItems = [
  { name: "Blogs", path: "/blogs" }
];
